import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MaterialLink from '../material-link';
import type { Group } from '../../types/Group';

type Props = {
  group: Group;
};

const GroupCalendarFooter = ({ group }: Props) => {
  return (
    <Box sx={{ mt: 3, textAlign: 'center' }}>
      <Typography variant="body2" color="text.primary">
        {group.permissions.createEvent && (
          <>
            Anyone can <MaterialLink href={`/events/new?groupId=${group.id}`}>add an event</MaterialLink> to
            the calendar.{' '}
          </>
        )}
        You can also <MaterialLink href={`/groups/${group.slug}/calendar/subscribe`}>subscribe</MaterialLink> to
        get updates.
        <br />
        <MaterialLink href="/about">Learn more</MaterialLink> about who posts these events.
      </Typography>
    </Box>
  );
};

export default GroupCalendarFooter;
